<template>
  <div class="container">
    <Card shadow>
<!--      <div>-->
<!--        <Breadcrumb>-->
<!--          <BreadcrumbItem to="/">首页</BreadcrumbItem>-->
<!--          <BreadcrumbItem>{{breadTitle}}</BreadcrumbItem>-->
<!--        </Breadcrumb>-->
<!--      </div>-->
      <SaleStep :current="current" v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'"></SaleStep>

      <Row class="pay-info-wrap">
        <Col span="24" style="text-align: center;">
          <Icon v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'" type="ios-checkmark-circle" color="#19be6b" class="type-icon" size="128" />
          <Icon v-else-if="orderInfo.status === '3'" type="ios-close-circle" color="#ed4014" class="type-icon" size="128" />
          <Icon v-else type="ios-information-circle" color="#f90" class="type-icon" size="128" />
          <h2>{{payTitle}}</h2>
          <!-- //Mod by LiuHui at 20201118 for 聚合支付 begin -->
          <!-- <p v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'">支付方式: 微信支付</p> -->
          <p v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'">支付方式: {{orderInfo.payTypeName}}</p>
          <!-- //Mod by LiuHui at 20201118 for 聚合支付 end -->
          <Spin size="large" fix v-if="statusLoading"></Spin>
        </Col>
      </Row>
      <Row class="pay-btn">
        <Col span="24" style="text-align: center;" v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'">
          <Button class="next-btn" @click="toContinue('buy')">继续购票</Button>
          <Button class="next-btn" @click="showOrderList('buy')">查看订单</Button>
        </Col>
        <Col span="24" style="text-align: center;" v-else>
          <Button class="next-btn" @click="toContinue('pay')">继续支付</Button>
          <Button class="next-btn" @click="showOrderList()">查看订单</Button>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
  import Vue from "vue"
  import { httpAction } from '@/api/manage'
  import SaleStep from '@/components/saleStep/Index'
  import QRCode from 'qrcodejs2'
  import common from '@/util/common'

  export default {
    inject: ['reload'],
    name: 'purchase-pay-end',
    components: {
      // calendar,
      SaleStep
    },
    data () {
      return {
        url: {
          indiOrderDetail: '/openapi/indi/orderDetail'
        },
        current: 3,
        orderInfo: {},
        iconArr: [
          { iconColor: 'icon-warning', iconType: 'ios-information-circle' },
          { iconColor: 'icon-success', iconType: 'ios-checkmark-circle' },
          { iconColor: 'icon-success', iconType: 'ios-checkmark-circle' },
          { iconColor: 'icon-error', iconType: 'ios-close-circle' },
          { iconColor: 'icon-error', iconType: 'ios-close-circle' }
        ],
        payTitle: '',
        breadTitle: '',
        statusLoading: true
      }
    },
    mounted () {
      this.getOrderDetail()
    },
    // beforeRouteEnter (to, from, next) {
    //   const orderId = Vue.ls.get('orderId')
    //   if (orderId) {
    //     next()
    //   } else {
    //     next(vm => {
    //       vm.$Message.warning('购票流程结束，请重新购票')
    //       vm.$router.push('/purchase/list')
    //     })
    //   }
    // },
    methods: {
      toContinue (type) {
        const orderId = this.$route.query.orderId ? this.$route.query.orderId : ''
        if (type === 'buy') {
          this.$router.push('/')
          this.reload()
          // Vue.ls.remove('orderId')
        } else {
          this.$router.push({ path: '/purchase/pay', query: { orderId } })
        }
      },
      showOrderList (type) {
        this.$router.push('/order')
        // 跳转绑定订单的tab modeby js
        Vue.ls.set('tabOn', '/order')
        this.reload()
        // if (type) {
        //   Vue.ls.remove('orderId')
        // }
      },
      async getOrderDetail () {
        const orderId = this.$route.query.orderId ? this.$route.query.orderId : ''
        // const orderId = Vue.ls.get('orderId')
        const obj = {
          id:orderId,
        }
        if (!orderId) { return false }
        const res = await httpAction(common.getOrderDetailUrl(), 'post', obj)
        if (res.status === '0') {
          this.orderInfo = {
            status: res.data ? res.data.status : '',
            statusName: res.data ? res.data.statusName : ''
          }
          switch (this.orderInfo.status) {
            case '1':
              this.payTitle = '订单支付成功'
              this.breadTitle = '支付成功'
              break
            case '2':
              this.payTitle = '订单已完成'
              this.breadTitle = '已完成'
              break
            case '3':
              this.payTitle = '订单已取消'
              this.breadTitle = '已取消'
              break
            case '4':
              this.payTitle = '订单已关闭'
              this.breadTitle = '已关闭'
              break
            default:
              this.payTitle = '订单待支付'
              this.breadTitle = '待支付'
              break
          }
          this.statusLoading = false
        }
      }
    }
  }
</script>

<style scoped>
  .container{
    margin-top:10px
  }
  .pay-info-wrap{
    margin: 40px 0 40px;
  }
  .next-btn{
    /*padding: 0 120px;*/
    height: 40px;
    margin-right: 20px;
  }
  .next-btn:last-child{
    margin-right: 0;
  }
  .pay-btn{
    margin-bottom: 40px;
  }
</style>
